export default __webpack_public_path__ + "static/media/Hood of Vindictive Malice.f06d41de.jpg";